export default __webpack_public_path__ + "static/media/TelaEntrada.17450915.png";